import { styled } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import { COLOR } from '@src/styles/color';

export const StyledDropzone = styled('div')`
  position: relative;
  width: 100%;
  padding: 40px;
  border: 1px dashed
    ${({ isError }) =>
      isError ? COLOR.functionalRed.default : COLOR.indigo[32]};
  border-radius: 16px;
  background: ${COLOR.charcoalV2[64]};
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: border-color 0.15s ease;
`;

export const StyledDropzoneInner = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`;

export const StyledDropzoneTextGroup = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  text-align: center;
`;

export const StyledDropzoneDescriptionGroup = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  /* Description paragraphs stack tight via natural line-height — no flex gap,
     matches Figma wrapping (same <div>, no gap). */
`;

export const StyledDropzoneTitle = styled('p')`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.4px;
  color: ${COLOR.darkGray};
  margin: 0;
`;

export const StyledDropzoneDescription = styled('p')`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: ${COLOR.label2[64]};
  margin: 0;
`;

export const StyledDropzoneErrorText = styled('p')`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: ${COLOR.functionalRed.default};
  margin: 0;
  text-align: center;
`;

// SRT validation produces HTML detail (block index, timestamps, failing text
// with red highlights). Render in a scrollable white card — mirrors legacy
// `.error-detail-wrapper` from `Dubbing/UploadSubtitleFile/index.style.js`.
export const StyledDropzoneErrorDetail = styled('div')`
  width: 100%;
  margin-top: 6px;
  padding: 12px 14px 12px 16px;
  border-radius: 12px;
  background: ${COLOR.white};
  box-sizing: border-box;
  font-size: 14px;
  text-align: left;
  max-height: 160px;
  overflow-y: overlay;
  cursor: default;

  ::-webkit-scrollbar {
    width: 2px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 12px;
    background-color: ${COLOR.white};
  }
  ::-webkit-scrollbar-thumb {
    background-color: ${COLOR.black[80]};
    border-radius: 12px;
  }
`;

export const StyledFileItem = styled('div')`
  width: 100%;
  padding: 16px;
  display: flex;
  gap: 16px;
  align-items: center;
  border: 0.5px solid ${COLOR.indigo[16]};
  border-radius: 12px;
  background: ${COLOR.white};
  box-sizing: border-box;
`;

export const StyledFileContent = styled('div')`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StyledFileIconWrap = styled('div')`
  width: 40px;
  height: 40px;
  padding: 4px;
  border-radius: 8px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  & svg,
  & img {
    width: 32px;
    height: 32px;
    display: block;
  }
`;

export const StyledFileInfo = styled('div')`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StyledLoaderWrap = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

export const StyledFileName = styled('p')`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.4px;
  color: ${COLOR.darkGray};
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const StyledFileDetails = styled('div')`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const StyledFileDetailText = styled('span')`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: ${COLOR.label2[64]};
`;

export const StyledDot = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  &::after {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: ${COLOR.label2[64]};
  }
`;

export const StyledDeleteBtn = styled(IconButton)`
  width: 32px;
  height: 32px;
  padding: 4px 8px;
  border: 0.5px solid ${COLOR.indigo[16]};
  border-radius: 8px;
  background: ${COLOR.white};
  flex-shrink: 0;
  & svg {
    width: 24px;
    height: 24px;
    color: ${COLOR.darkGray};
  }
  &:hover {
    background: ${COLOR.indigo[4]};
  }
`;
